// The mock flag (docs/design/brand-direction/BACKEND-GAPS.md): screens whose backend does not exist yet run on
// typed mock sources when it is on. On in `vite dev` unless VITE_MOCK_DATA=0; off in production builds unless
// VITE_MOCK_DATA=1. Pure.

export interface FlagEnv {
  DEV?: boolean;
  VITE_MOCK_DATA?: string;
}

export function mocksOn(env: FlagEnv = import.meta.env): boolean {
  const v = env.VITE_MOCK_DATA?.trim().toLowerCase();
  if (v === "1" || v === "true") return true;
  if (v === "0" || v === "false") return false;
  return !!env.DEV;
}
